namespace Matrix.Data {
    export interface SourceRow {
        SourceCode?: string;
        Name?: string;
        Group?: string;
        Category?: string;
    }

    export namespace SourceRow {
        export const idProperty = 'SourceCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Source';
        export const lookupKey = 'Data.Source';

        export function getLookup(): Q.Lookup<SourceRow> {
            return Q.getLookup<SourceRow>('Data.Source');
        }
        export const deletePermission = 'DataAdmin:Source';
        export const insertPermission = 'DataAdmin:Source';
        export const readPermission = 'Read:Source';
        export const updatePermission = 'DataAdmin:Source';

        export declare const enum Fields {
            SourceCode = "SourceCode",
            Name = "Name",
            Group = "Group",
            Category = "Category"
        }
    }
}
